// システムID略称
const ABBR_SYS_NAME = require('../data/abbrSysName.json');

/**
 * システムの略称を取得する
 * @param {string} systemName システム名
 * @returns {string} システム略称
 */
export const getAbbrSysName = (systemName) => {
  return ABBR_SYS_NAME[systemName] || systemName;
};

export default {
  getAbbrSysName
};
